import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Paper, Typography, Button, Badge} from "@material-ui/core";
import {NavigateBefore, Menu, NavigateNext, Visibility, VisibilityOff, CloudQueue} from '@material-ui/icons';
import {createWriteStream} from "streamsaver";
import {IParcela, ISections, IZona} from "../../../types";
import DatePicker, {registerLocale} from "react-datepicker";
import es from 'date-fns/locale/es';
import {userService} from "../../../services/UserService";
import Basura from "../../../icons/SVGs/Delete.svg"
import Descarga from "../../../icons/SVGs/Paper Download.svg"
import {resolucion_tablet} from "../../../tools/resolucion";
import {KeyboardDateTimePicker, KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {MaterialUiPickersDate} from "@material-ui/pickers/typings/date";
import DateUtils from "@date-io/moment";
import axios from "axios";
import CloudsAlert from "../../../icons/PNGs/cluds_alert.png";
import moment from "moment";

registerLocale('es', es)


const config = require('../../../config.json');
const texts = require('../../../texts/visualizador.json');


interface IProps {
    selectSection(section: ISections): void
    setSelected(selected: string[]): void
    setProduct(product: string): void
    setMenu(menu: boolean): void
    setZonificacion(zonificacion: boolean): void
    selectZonificacion(zonificacion_selected: string): void
    setZonificaciones(zonificaciones: IZona[]): void
    setPropsZonificacion(props_zonificacion: boolean): void
    openLoadingDialog(callback: boolean): void
    NotasCampo(notas_campo: boolean): void
    setInitRotatedLayer(init_rotated_layer: boolean): void
    parcela: IParcela
    products: Record<string, Record<string, string[]>>
    selected: string[]
    product: string
    zonificacion: boolean
    menu: boolean
    zonificaciones: IZona[]
    zonificacion_selected: string
    props_zonificacion: boolean
    init_rotated_layer: boolean
    notas_campo: boolean
    idioma: string
    level: number
}

interface IState {
    fuente: string
    fecha: Date | null
    indice: string
    producto: string
    opcionesFuente: boolean
    opcionesFecha: boolean
    opcionesIndice: boolean
    opcionesProducto: boolean
    vertical: boolean
    cambiando: boolean
    text: Record<string, string>
    nublados: string[]
    iniciando: boolean
}



class MenuVisualizador extends React.Component<IProps, IState> {
    state: IState = {
        fuente: '',
        fecha: null,
        indice: '',
        producto: '',
        opcionesFuente: false,
        opcionesFecha: false,
        opcionesIndice: false,
        opcionesProducto: false,
        vertical: window.matchMedia("(orientation: portrait)").matches,
        cambiando: false,
        text: texts[this.props.idioma],
        nublados: [] as string[],
        iniciando: false
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    componentDidMount() {
        this.props.setZonificaciones([] as IZona[])
        this.props.setInitRotatedLayer(false)
    }

    downloadFile = (url:string, fileName:string): Promise<void> => {
        return fetch(url)
            .then(res => {
                const fileStream = createWriteStream(fileName);
                const writer = fileStream.getWriter();
                if (res.body !== null) {
                    if (res.body.pipeTo) {
                        writer.releaseLock();
                        return res.body.pipeTo(fileStream);
                    }

                    const reader = res.body.getReader();

                    const pump = (): Promise<void> =>
                        reader
                            .read()
                            .then(({ value, done }) =>
                                (done ? writer.close() : writer.write(value).then(pump))
                            );

                    return pump();
                }

            })
            .catch(() => {})
    };

    includedDate = (date: MaterialUiPickersDate): boolean => {
        if (date !== null) {
            if (this.state.fuente === '') return false
            let dates: string[] = []

            if (this.state.fuente === "dron") {
                for (const dia of Object.keys(this.props.products["rpas"])) {
                    if (this.props.products["rpas"][dia].includes(this.state.indice)) {
                        let f = dia.split('_').reverse()
                        dates.push(`${parseInt(f[0])}/${parseInt(f[1])}/${parseInt(f[2])}`)
                    }
                }
                return !dates.includes(date.toDate().toLocaleDateString('es'))
            }

            if (this.state.fuente === "satelite") {
                let fuente = "sentinel_2a"
                if (this.state.indice === "lst") fuente = "landsat_8"
                for (const dia of Object.keys(this.props.products[fuente])) {
                    if (this.props.products[fuente][dia].includes(this.state.indice)) {
                        let f = dia.split('_').reverse()
                        dates.push(`${parseInt(f[0])}/${parseInt(f[1])}/${parseInt(f[2])}`)
                    }
                }
                return !dates.includes(date.toDate().toLocaleDateString('es'))
            }

            if (this.state.fuente === "cropsense") {
                let indice_name = "ETc_24"
                if (this.state.indice == "Humedad") indice_name = "humedad"
                for (const dia of Object.keys(this.props.products[this.state.indice])) {
                    if (this.props.products[this.state.indice][dia].includes(indice_name)) {
                        let f = dia.split('_').reverse()
                        dates.push(`${parseInt(f[0])}/${parseInt(f[1])}/${parseInt(f[2])}`)
                    }
                }
                return !dates.includes(date.toDate().toLocaleDateString('es'))
            }

        }
        return true
    }

    fechasDisponibles = (): Boolean => {
        if (this.state.fuente === "dron") {
            for (const dia of Object.keys(this.props.products["rpas"])) {
                if (this.props.products["rpas"][dia].includes(this.state.indice)) {
                    return true
                }
            }
        }
        if (this.state.fuente === "satelite") {
            let fuente = "sentinel_2a"
            if (this.state.indice === "lst") fuente = "landsat_8"
            for (const dia of Object.keys(this.props.products[fuente])) {
                if (this.props.products[fuente][dia].includes(this.state.indice)) {
                    return true
                }
            }
        }
        if (this.state.fuente === "cropsense") {
            let indice_name = "ETc_24"
            if (this.state.indice == "Humedad") indice_name = "humedad"
            for (const dia of Object.keys(this.props.products[this.state.indice])) {
                if (this.props.products[this.state.indice][dia].includes(indice_name)) {
                    return true
                }
            }
        }
        return false
    }

    handleAdd = () => {
        let year: string
        let month: string
        let day: string
        let fecha: string = ''
        if (this.state.fecha !== null) {
            let f: string[] = this.state.fecha.toLocaleDateString('es').split('/').reverse()
            year = f[0]
            if (f[1].length < 2) {
                month = '0'+f[1]
            } else {
                month = f[1]
            }
            if (f[2].length < 2) {
                day = '0'+f[2]
            } else {
                day = f[2]
            }
            fecha = year + '_' + month + '_' + day
            let selected = [] as string[]
            let selection = ''
            selection = this.state.fuente + ',' + fecha + ',' + this.state.indice

            if (this.state.fuente === "satelite") {
                let fuente = "sentinel_2a"
                if (this.state.indice.toLowerCase() === "lst") fuente = "landsat_8"

                axios.get(
                    config.url+`/datos/nublados?fuente=${fuente}&parcela=${this.props.parcela.id}&fecha=${fecha}`,
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }})
                    .then((res) => {
                        if (res.data.nublados) {
                            selection += ",clouds"
                        }
                        selected.push(selection)
                        for (let el of this.props.selected){
                            if (el === selection) continue
                            selected.push(el)
                        }
                        this.props.setSelected(selected)

                    })
                    .catch(() => {
                        selected.push(selection)
                        for (let el of this.props.selected){
                            if (el === selection) continue
                            selected.push(el)
                        }
                        this.props.setSelected(selected)
                    })
            } else {
                selected.push(selection)
                for (let el of this.props.selected){
                    if (el === selection) continue
                    selected.push(el)
                }
                this.props.setSelected(selected)
            }
        } else {
            fecha = "atemporal"
            let selected = []
            let selection = ''
            selection = this.state.fuente + ',' + fecha + ',' + this.state.indice
            selected.push(selection)
            for (let el of this.props.selected){
                if (el === selection) continue
                selected.push(el)
            }
            this.props.setSelected(selected)
        }
    }

    setNublados = (indice: string) => {
        if (this.state.fuente === "satelite") {
            let fuente = "sentinel_2a"
            if (indice.toLowerCase() === "lst") fuente = "landsat_8"

            axios.get(
                config.url+`/fechas/nubladas?fuente=${fuente}&parcela=${this.props.parcela.id}`,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {
                    this.setState({nublados: res.data.nublados as string[]})
                })
                .catch(() => {
                    this.setState({nublados: [] as string[]})
                })
        } else {
            this.setState({nublados: [] as string[]})
        }
    }

    isDisabled = (i: string) : boolean => {
        if (userService.getUser() === "demo") return false
        if (this.props.level < 4 && ["Humedad", "clay"].includes(i)) return true
        return false
    }

    render () {
        const doOnOrientationChange = () => {
            if (!this.state.cambiando) {
                this.setState({cambiando: true, vertical: !this.state.vertical})
                setTimeout(() => this.setState({cambiando: false}), 100)
            }
        }

        window.addEventListener("orientationchange", function() {
            doOnOrientationChange()
        }, false)

        let indices: string[] = []

        if (this.state.fuente == "satelite") indices = ["ndmi","ndvi", "ndwi", "gndvi", "ndre", "savi", "rgb", "lst"]
        if (this.state.fuente == "cropsense") indices = ["ETc_hibrida", "ETc_high", "ETc_low", "dsm", "clay", "Humedad"]
        if (this.state.fuente == "dron") {
            indices = ["lst", "rgb", "ndvi"]

            for(let f of Object.keys(this.props.products["rpas"])) {
                for (let indc of this.props.products["rpas"][f]) {
                    if (!indices.includes(indc)) indices.push(indc)
                }
            }

        }


        if (this.props.menu) {
            return (
                <div
                    style={{
                        height: '100%',
                        width: this.state.vertical?
                            resolucion_tablet()? '40%' : '100%'
                            :
                            resolucion_tablet()? '30%' : '40%'
                        ,
                        marginRight: this.state.vertical?
                            resolucion_tablet()? '-40%' : '-100%'
                            :
                            resolucion_tablet()? '-30%' : '-40%'
                        ,
                        backgroundColor: 'rgba(255,255,255, 0.95)',
                        zIndex: 200,
                        borderTopRightRadius: this.props.zonificacion || this.props.props_zonificacion? 0 : 40,
                        borderBottomRightRadius: !resolucion_tablet() && (this.props.zonificacion || this.props.props_zonificacion)? 0 :  40,
                        overflow: "auto",
                        direction: 'rtl'
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            height: '100%',
                            width:'100%',
                            alignItems: "center",
                            direction: 'ltr'
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginTop: 40,
                            }}
                        >
                            <Typography
                                style={{
                                    marginLeft: 20,
                                    fontWeight: "bold",
                                    fontSize: 32,
                                    color: '#4b484a'
                                }}
                            >
                                {this.state.text["8"]}
                            </Typography>
                            <Button
                                style={{
                                    width: "fit-content",
                                    height: "fit-content",
                                    alignSelf: "center"
                                }}
                                onClick={() => this.props.setMenu(false)}
                            >
                                <Menu
                                    style={{
                                        height: 35,
                                        width: 35
                                    }}
                                />
                            </Button>
                        </div>


                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                width: '100%'
                            }}
                        >


                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '100%',
                                    marginTop: 30,
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >

                                <Button
                                    style={{
                                        backgroundColor: this.props.notas_campo? "#80ED99" : '#C7F9CC',
                                        width: '90%',
                                        borderRadius: 10,
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "space-between"
                                    }}
                                    onClick={() => this.props.NotasCampo(!this.props.notas_campo)}
                                    variant={"contained"}
                                >
                                    <Typography
                                        style={{
                                            marginLeft: 5,
                                            fontWeight: "bold",
                                            fontSize: 18,
                                            color: '#4b484a'
                                        }}
                                    >
                                        {this.state.text["9"]}
                                    </Typography>
                                    {this.props.notas_campo?
                                        <Visibility
                                            style={{
                                                width: 30,
                                                height: 30,
                                                cursor: "pointer",
                                                color: '#4C494B'
                                            }}
                                        />
                                        :
                                        <VisibilityOff
                                            style={{
                                                width: 30,
                                                height: 30,
                                                cursor: "pointer",
                                                color: '#4C494B'
                                            }}
                                        />
                                    }
                                </Button>

                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '100%',
                                    justifyContent: "space-between",
                                    marginTop: 20,
                                    alignItems: "center"
                                }}
                            >
                                <Typography
                                    style={{
                                        marginLeft: 20,
                                        fontWeight: "bold",
                                        fontSize: 18,
                                        color: '#4b484a'
                                    }}
                                >
                                    {this.state.text["10"]}
                                </Typography>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    }}
                                >

                                    <Typography
                                        style={{
                                            marginLeft: 20,
                                            fontWeight: "bold",
                                            fontSize: 18,
                                            color: '#80ED99',
                                            marginRight: 20
                                        }}
                                    >
                                        {this.state.text[this.state.fuente]}
                                    </Typography>

                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                opcionesFuente: !this.state.opcionesFuente,
                                                opcionesIndice: false,
                                                opcionesFecha: false
                                            })
                                        }}
                                    >
                                        {this.state.opcionesFuente?
                                            <NavigateBefore
                                                style={{
                                                    height: 30,
                                                    width: 30
                                                }}
                                            />
                                            :
                                            <NavigateNext
                                                style={{
                                                    height: 30,
                                                    width: 30
                                                }}
                                            />
                                        }
                                    </Button>
                                </div>
                            </div>

                            {this.state.opcionesFuente &&
                                ["dron", "satelite", "cropsense"].map(f =>
                                <Button
                                    key={f}
                                    style={{
                                        textTransform: "none",
                                        backgroundColor: "white",
                                        width: '80%',
                                        marginBottom: 10
                                    }}
                                    onClick={() => this.setState({
                                        fuente: f,
                                        opcionesFuente: false,
                                        indice: '',
                                        fecha: null
                                    })}
                                >
                                    <Typography
                                        style={{
                                            fontSize: 20
                                        }}
                                    >
                                        {this.state.text[f]}
                                    </Typography>
                                </Button>
                            )
                            }

                        </div>

                        <div
                            style={{
                                width: '90%',
                                height: 0,
                                borderWidth: 1,
                                borderStyle: "solid",
                                borderColor:'#4b484a',
                                alignSelf: "center",
                                marginBottom:10
                            }}
                        />

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            <Typography
                                style={{
                                    marginLeft: 20,
                                    fontWeight: "bold",
                                    fontSize: 18,
                                    color: '#4b484a'
                                }}
                            >
                                {this.state.text["13"]}
                            </Typography>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center"
                                }}
                            >

                                <Typography
                                    style={{
                                        marginLeft: 20,
                                        fontWeight: "bold",
                                        fontSize: 18,
                                        color: '#80ED99',
                                        marginRight: 20
                                    }}
                                >
                                    {this.state.text["indices"].split(',').includes(this.state.indice)?
                                        this.state.text[this.state.indice]
                                        :
                                        this.state.indice
                                    }
                                </Typography>

                                <Button
                                    onClick={() => {
                                        this.setState({
                                            opcionesIndice: !this.state.opcionesIndice,
                                            opcionesFuente: false,
                                            opcionesFecha: false
                                        })
                                    }}
                                >
                                    {this.state.opcionesIndice?
                                        <NavigateBefore
                                            style={{
                                                height: 30,
                                                width: 30
                                            }}
                                        />
                                        :
                                        <NavigateNext
                                            style={{
                                                height: 30,
                                                width: 30
                                            }}
                                        />
                                    }
                                </Button>
                            </div>
                        </div>

                        {this.state.opcionesIndice &&
                            indices.map(i =>
                                <Button
                                    key={i}
                                    style={{
                                        textTransform: "none",
                                        backgroundColor: "white",
                                        width: '80%',
                                        marginBottom: 10
                                    }}
                                    disabled={this.isDisabled(i)}
                                    onClick={() => {
                                        this.setNublados(i)
                                        this.setState({
                                            indice: i,
                                            opcionesIndice: false,
                                            fecha: null
                                        })
                                    }}
                                >
                                    <Typography
                                        style={{
                                            fontSize: 20
                                        }}
                                    >
                                        {this.state.text["indices"].split(',').includes(i)?
                                            this.state.text[i]
                                            :
                                            i
                                        }
                                    </Typography>
                                </Button>
                            )
                        }


                        {!["dsm", "clay"].includes(this.state.indice) &&
                            <div
                                style={{
                                    width: '90%',
                                    height: 0,
                                    borderWidth: 1,
                                    borderStyle: "solid",
                                    borderColor: '#4b484a',
                                    alignSelf: "center",
                                    marginBottom: 10
                                }}
                            />
                        }


                        {!["dsm", "clay"].includes(this.state.indice) &&

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '100%',
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                <Typography
                                    style={{
                                        marginLeft: 20,
                                        fontWeight: "bold",
                                        fontSize: 18,
                                        color: '#4b484a'
                                    }}
                                >
                                    {this.state.text["12"]}
                                </Typography>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    }}
                                >

                                    <Typography
                                        style={{
                                            marginLeft: 20,
                                            fontWeight: "bold",
                                            fontSize: 18,
                                            color: '#80ED99',
                                            marginRight: 20
                                        }}
                                    >
                                        {this.state.fecha === null? '' : this.state.fecha.toLocaleDateString('es')}
                                    </Typography>

                                    <Button
                                        onClick={() => {
                                            if (this.state.indice.length === 0) return
                                            if (!this.fechasDisponibles()) return;
                                            this.setState({
                                                opcionesFecha: !this.state.opcionesFecha,
                                                opcionesFuente: false,
                                                opcionesIndice: false
                                            })
                                        }}
                                    >
                                        {this.state.opcionesFecha?
                                            <NavigateBefore
                                                style={{
                                                    height: 30,
                                                    width: 30
                                                }}
                                            />
                                            :
                                            <NavigateNext
                                                style={{
                                                    height: 30,
                                                    width: 30
                                                }}
                                            />
                                        }
                                    </Button>
                                </div>
                            </div>
                        }

                        {this.state.opcionesFecha &&
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                justifyContent: "center"
                            }}
                        >
                            <MuiPickersUtilsProvider
                                locale={this.props.idioma}
                                utils={DateUtils}
                            >
                                <KeyboardDatePicker
                                    value={this.state.fecha !== null? this.state.fecha : null}
                                    open={this.state.opcionesFecha}
                                    onChange={(f) => {
                                        if (f !== null) this.setState({
                                            fecha: f.toDate(),
                                            opcionesFecha: false
                                        })
                                    }}
                                    renderDay={(day, selectedDate, isInCurrentMonth, dayComponent) => {
                                        let isSelected = false
                                        if (isInCurrentMonth) {
                                            if (day !== null) {
                                                if (this.state.nublados.includes(moment(day.toDate()).format('YYYY_MM_DD'))) isSelected = true
                                            }
                                        }
                                        return <Badge>
                                            {dayComponent}
                                            {isSelected &&
                                                <CloudQueue
                                                    style={{
                                                        color: "#305ccc",
                                                        marginLeft: -10,
                                                        marginTop: -5
                                                    }}
                                                />
                                            }
                                        </Badge>
                                    }}
                                    onClose={() => this.setState({opcionesFecha: false})}
                                    shouldDisableDate={this.includedDate}
                                    format="dd/MM/yyyy"
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        }



                        <div
                            style={{
                                width: '90%',
                                height: 0,
                                borderWidth: 1,
                                borderStyle: "solid",
                                borderColor:'#4b484a',
                                alignSelf: "center",
                                marginBottom:10
                            }}
                        />



                        <Button
                            style={{
                                backgroundColor: ["dsm", "clay"].includes(this.state.indice)?
                                    this.state.indice === "clay" && Object.keys(this.props.products["Clay"]).length === 0?
                                        "#ccc" : "#80ED99"
                                    :
                                    this.state.fecha === null? "#ccc" : '#80ED99',
                                width: '90%',
                                marginTop: 20,
                                marginBottom: 20,
                                borderRadius: 10
                            }}
                            disabled={["dsm", "clay"].includes(this.state.indice)?
                                this.state.indice === "clay" && Object.keys(this.props.products["Clay"]).length === 0
                                :
                                this.state.fecha === null
                            }
                            onClick={() => this.handleAdd()}
                            variant={"contained"}
                        >
                            <Typography
                                style={{
                                    textTransform: "none",
                                    color: '#4b484a',
                                    fontWeight: "bold",
                                    fontSize: 18,
                                }}
                            >
                                {this.state.text["14"]}
                            </Typography>
                        </Button>




                        {this.props.selected.map(element =>
                            <Paper
                                key={element}
                                elevation={1}
                                style={{
                                    backgroundColor: this.props.product === element ? '#80ED99' : "white",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    width: '90%',
                                    height: 90,
                                    marginBottom: 5,
                                    borderRadius: 10,
                                    cursor: "pointer"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        height: '100%',
                                        marginLeft: 15,
                                        alignItems: "flex-start",
                                        width: 'calc(100% - 60px)'
                                    }}
                                    onClick={() => {

                                        this.props.setProduct(element)
                                        if (!this.props.init_rotated_layer){
                                            this.setState({iniciando: true})
                                            this.props.openLoadingDialog(true)
                                            setTimeout(() => this.props.setProduct(""), 500)
                                            setTimeout(() => {
                                                this.setState({iniciando: false})
                                                this.props.setProduct(element)
                                                this.props.openLoadingDialog(false)
                                                this.props.setInitRotatedLayer(true)
                                            }, 2000)
                                        }
                                        this.props.selectZonificacion('')
                                        this.props.setZonificacion(false)
                                        this.props.setPropsZonificacion(false)
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textTransform: 'none',
                                            marginTop: element.split(',')[1] !== "atemporal"? 5 : 10
                                        }}
                                    >
                                        {this.state.text[element.split(',')[0]]}
                                    </Typography>

                                    {element.split(',')[1] !== "atemporal" &&
                                        <Typography
                                            style={{
                                                textTransform: 'none'
                                            }}
                                        >
                                            {element.split(',')[1].split('_').reverse().join('/')}
                                        </Typography>
                                    }

                                    <Typography
                                        style={{
                                            fontWeight: "bold",
                                            marginBottom: element.split(',')[1] !== "atemporal"? 5 : 10,
                                            textTransform: 'none'
                                        }}
                                    >
                                        {this.state.text["indices"].split(',').includes(element.split(',')[2])?
                                            this.state.text[element.split(',')[2]]
                                            :
                                            element.split(',')[2]
                                        }
                                    </Typography>
                                </div>

                                {element.includes(",clouds") &&
                                    <div
                                        style={{
                                            width: "fit-content",
                                            height: "fit-content",
                                            // marginTop: -50,
                                            backgroundColor: "transparent"
                                        }}
                                    >
                                        <img style={{width: 50}} src={CloudsAlert} alt=''/>
                                    </div>
                                }

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        height: '100%',
                                        width: 60
                                    }}
                                >
                                    <Button
                                        style={{
                                            width: "fit-content",
                                            height: "fit-content",
                                            borderRadius: 10,
                                        }}
                                        onClick={() => {

                                            let fuente = ""
                                            const parcela = this.props.parcela.id
                                            const fecha = (this.props.product.split(',')[1]).split('/').reverse().join('-')
                                            let indice = ""

                                            if (["Humedad"].includes(this.props.product.split(',')[2])) {
                                                fuente = 'Humedad'
                                                indice = 'humedad'
                                            }
                                            if (["ETc_hibrida", "ETc_high", "ETc_low"].includes(this.props.product.split(',')[2])) {
                                                fuente = this.props.product.split(',')[2]
                                                indice = 'ETc_24'
                                            }
                                            if (this.props.product.split(',')[0]==="satelite" && this.props.product.split(',')[2] === "lst") {
                                                fuente = 'landsat_8'
                                                indice = this.props.product.split(',')[2]
                                            }
                                            if (this.props.product.split(',')[0]==="satelite" && this.props.product.split(',')[2] !== "lst") {
                                                fuente = 'sentinel_2a'
                                                indice = this.props.product.split(',')[2]
                                            }
                                            if (this.props.product.split(',')[0]==="dron") {
                                                fuente = 'rpas'
                                                indice = this.props.product.split(',')[2]
                                            }

                                            const url = config.url+`/static/visualizador/${fuente}/${parcela}/${fecha}/${indice}.tif`
                                            this.downloadFile(url, element.split(',').join('_').split('/').join('-')+'.tif')
                                        }}
                                    >
                                        <img
                                            style={{
                                                height: 30,
                                                width: 30
                                            }}
                                            src={Descarga}
                                            alt=""
                                        />
                                    </Button>

                                    <Button
                                        style={{
                                            width: "fit-content",
                                            height: "fit-content",
                                            borderRadius: 10
                                        }}
                                        onClick={() => {
                                            if (this.props.product === element) {
                                                this.props.setProduct('')
                                                if (this.props.zonificacion) {
                                                    this.props.setZonificacion(false)
                                                    this.props.setPropsZonificacion(false)
                                                }
                                            }
                                            let selected: string[] = []
                                            for (let el of this.props.selected){
                                                if (el === element) continue
                                                selected.push(el)
                                            }
                                            this.props.setSelected(selected)
                                        }}
                                    >
                                        <img
                                            style={{
                                                height: 30,
                                                width: 30
                                            }}
                                            src={Basura}
                                            alt=""
                                        />
                                    </Button>

                                </div>

                            </Paper>
                        )}

                        {this.props.zonificaciones.length > 0 && this.props.selected.length > 0 &&
                            <div
                                style={{
                                    width: '90%',
                                    height: 0,
                                    borderWidth: 1,
                                    borderStyle: "solid",
                                    borderColor:'#4b484a',
                                    alignSelf: "center",
                                    marginBottom: 10,
                                    marginTop: 10
                                }}
                            />
                        }

                        {this.props.zonificaciones.map(element =>
                            <Paper
                                key={element.id}
                                elevation={1}
                                style={{
                                    backgroundColor: this.props.zonificacion_selected === element.id ? '#C7F9CC' : "white",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    width: '90%',
                                    height: 90,
                                    marginBottom: 5,
                                    borderRadius: 10,
                                    cursor: "pointer"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        height: '100%',
                                        marginLeft: 15,
                                        alignItems: "flex-start",
                                        width: 'calc(100% - 60px)'
                                    }}
                                    onClick={() => {
                                        this.props.selectZonificacion(element.id)
                                        this.props.setProduct('')
                                        this.props.setZonificacion(false)
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textTransform: 'none',
                                            marginTop: element.id.includes("atemporal")? 10 : 5,
                                            fontWeight: "bold"
                                        }}
                                    >
                                        {element.id.split(',')[4]}
                                    </Typography>
                                    <Typography
                                        style={{
                                            textTransform: 'none',
                                            fontSize: 12
                                        }}
                                    >
                                        {element.id.split(',')[0] === 'rpas' && this.state.text["dron"]}
                                        {element.id.split(',')[0] === 'sentinel_2a' && this.state.text["satelite"]}
                                        {element.id.split(',')[0] === 'landsat_8' && this.state.text["satelite"]}
                                        {element.id.split(',')[0] === 'ETc_hibrida' && this.state.text["cropsense"]}
                                        {element.id.split(',')[0] === 'ETc_high' && this.state.text["cropsense"]}
                                        {element.id.split(',')[0] === 'ETc_low' && this.state.text["cropsense"]}
                                        {element.id.split(',')[0] === 'Humedad' && this.state.text["cropsense"]}
                                    </Typography>

                                    {!element.id.includes("atemporal") &&
                                        <Typography
                                            style={{
                                                textTransform: 'none',
                                                fontSize: 12
                                            }}
                                        >
                                            {element.id.split(',')[2].split('_').reverse().join('/')}
                                        </Typography>
                                    }

                                    <Typography
                                        style={{
                                            fontWeight: "bold",
                                            marginBottom: element.id.includes("atemporal")? 10 : 5,
                                            textTransform: 'none',
                                            fontSize: 12
                                        }}
                                    >
                                        {["ETc_hibrida", "ETc_high", "ETc_low", "Humedad"].includes(element.id.split(',')[0])?
                                            this.state.text[element.id.split(',')[0]]
                                            :
                                            this.state.text["indices"].split(',').includes(element.id.split(',')[3])?
                                                this.state.text[element.id.split(',')[3]]
                                                :
                                                element.id.split(',')[3]
                                        }
                                    </Typography>

                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        height: '100%',
                                        width: 60
                                    }}
                                >
                                    <Button
                                        style={{
                                            width: "fit-content",
                                            height: "fit-content",
                                            borderRadius: 10,
                                        }}
                                        onClick={() => {
                                            const url = config.url+`/static/visualizador/zonificaciones/${userService.getUser()}/${element.id.split(',')[0]}/${this.props.parcela.id}/${element.id.split(',')[2]}/${element.id.split(',')[3]}/${element.id.split(',')[4]}/${element.id.split(',')[4]}.zip`
                                            this.downloadFile(url, `${element.id.split(',')[4]}.zip`)
                                        }}
                                    >
                                        <img
                                            style={{
                                                height: 30,
                                                width: 30,
                                                zIndex: 400
                                            }}
                                            src={Descarga}
                                            alt=""
                                        />
                                    </Button>

                                    <Button
                                        style={{
                                            width: "fit-content",
                                            height: "fit-content",
                                            borderRadius: 10
                                        }}
                                        onClick={() => {
                                            if (this.props.zonificacion_selected === element.id) {
                                                this.props.selectZonificacion('')
                                            }
                                            if (this.props.props_zonificacion) {
                                                this.props.setPropsZonificacion(false)
                                            }
                                            const zonificaciones = []
                                            for (const zona of this.props.zonificaciones) {
                                                if (zona.id === element.id) continue
                                                zonificaciones.push(zona)
                                            }
                                            this.props.setZonificaciones(zonificaciones)
                                        }}
                                    >
                                        <img
                                            style={{
                                                height: 30,
                                                width: 30
                                            }}
                                            src={Basura}
                                            alt=""
                                        />
                                    </Button>

                                </div>
                            </Paper>

                        )}



                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                height: '100%',
                                alignSelf: "flex-end",
                                justifyContent: "flex-end",
                                marginBottom: 20
                            }}
                        >
                            <Button
                                style={{
                                    alignSelf: "flex-end",
                                    marginRight: 40
                                }}
                                onClick={() => {
                                    this.props.setProduct('')
                                    this.props.setSelected([])
                                    this.props.selectSection('principal')
                                    this.props.setZonificacion(false)
                                    this.props.setPropsZonificacion(false)
                                }}
                            >
                                <NavigateBefore
                                    style={{
                                        height: 30,
                                        width: 30
                                    }}
                                />
                                <Typography
                                    style={{
                                        textTransform: "none",
                                        fontSize: 20,
                                        fontWeight: "bold",
                                        marginLeft: 10,
                                        textDecoration: 'underline'
                                    }}
                                >
                                    {this.state.text["15"]}
                                </Typography>
                            </Button>
                        </div>

                    </div>
                </div>
            )
        } else {
            return (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        alignSelf: "flex-start",
                        height: this.state.vertical? 60 : '100%',
                        width: 60,
                        marginRight: -60,
                        marginTop: this.state.vertical? 20 : 0,
                        backgroundColor: 'rgba(255,255,255,0.95)',
                        zIndex: 200,
                        borderTopRightRadius: this.props.zonificacion || this.props.props_zonificacion? 0 : 40,
                        borderBottomRightRadius: !resolucion_tablet() && (this.props.zonificacion || this.props.props_zonificacion)? 0 :  40,
                    }}
                >
                    <Button
                        style={{
                            marginTop: this.state.vertical? 0 : 20,
                            width: 60,
                            height: 60,
                            borderRadius: 20
                        }}
                        onClick={() => this.props.setMenu(true)}
                    >
                        <Menu
                            style={{
                                height: 35,
                                width: 35
                            }}
                        />
                    </Button>
                </div>
            )
        }
    }

}


const mapStateToProps = (state: IStore) => ({
    parcela: state.visualizador.parcela,
    products: state.visualizador.products,
    selected: state.visualizador.selected,
    product: state.visualizador.product,
    zonificacion: state.visualizador.zonificacion,
    menu: state.visualizador.menu,
    zonificaciones: state.visualizador.zonificaciones,
    zonificacion_selected: state.visualizador.zonificacion_selected,
    props_zonificacion: state.visualizador.props_zonificacion,
    init_rotated_layer: state.visualizador.init_rotated_layer,
    notas_campo: state.visualizador.notas_campo,
    idioma: state.config.idioma,
    level: state.navegacion.level
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    selectSection: (section: ISections) => dispatch({type: "select-section", section}),
    setSelected: (selected: string[]) => dispatch({type: "set-visualizador-selected", selected}),
    setProduct: (product: string) => dispatch({type: "set-visualizador-product", product}),
    setMenu: (menu: boolean) => dispatch({type: "set-visualizador-menu", menu}),
    setZonificacion: (zonificacion: boolean) => dispatch({type: "set-visualizador-zonificacion", zonificacion}),
    selectZonificacion: (zonificacion_selected: string) => dispatch({type: "set-visualizador-zonificacion-selected", zonificacion_selected}),
    setZonificaciones: (zonificaciones: IZona[]) => dispatch({type: "set-visualizador-zonificaciones", zonificaciones}),
    setPropsZonificacion: (props_zonificacion: boolean) => dispatch({type: "set-visualizador-props-zonificacion", props_zonificacion}),
    openLoadingDialog: (callback: boolean) => dispatch({type: "open-loading-dialog", callback}),
    NotasCampo: (notas_campo: boolean) => dispatch({type: "notas-campo", notas_campo}),
    setInitRotatedLayer: (init_rotated_layer: boolean) => dispatch({type: "init-rotated-layer", init_rotated_layer})
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuVisualizador);
